import { Md5 } from 'md5-typescript';
import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { HttpParams } from '@angular/common/http';
import { CustomEncoder } from './custom-encoder';
import { IToken } from '../models/utils';
import { unmaskFields, unmaskValue } from '../utils/mask.utils';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(private http: HttpService) {}

  login(cpf_cnpj: string, password: string) {
    const body = new HttpParams()
      // .set('username', email)
      // Envia o CPF/CNPJ apenas com dígitos, sem a máscara.
      .set('cpf_or_cnpj', unmaskValue(cpf_cnpj))

      .set('password', Md5.init(password).toUpperCase());

    return this.http.post<IToken>('core/auth/', body);
  }

  // login(username: any, password: any): Observable<any> {
  //   var passwordMD5 = Md5.init(password).toUpperCase();

  //   const body = new HttpParams()
  //     .set(`username`, username)
  //     .set(`password`, passwordMD5)

  //   const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

  //   return this.http.post<any>(AppConfig.path + "core/auth/", body, { headers })
  // }

  getMe() {
    return this.http.get<any>('core/get-user/');
  }

  editProfile(user: any) {
    // Remove a máscara (pontuação) dos campos de CEP, CPF/CNPJ, telefone e
    // celular antes de enviar ao back. O front continua exibindo a máscara.
    const cleaned = unmaskFields(user);

    let body = new HttpParams({ encoder: new CustomEncoder() });

    Object.keys(cleaned).reduce((acc, key) => {
      if (cleaned[key] != null && cleaned[key] !== '')
        if (
          key !== 'updated_at' &&
          key !== 'created_at' &&
          key !== 'profile_image' &&
          key !== 'menu_user' &&
          key !== 'terms_accepted' &&
          key !== 'type' &&
          key !== 'is_admin' &&
          key !== 'is_active' &&
          key !== 'cpf_or_cnpj' &&
          key !== 'birth_date' &&
          key !== 'id'
        ) {
          body = body.set(key, cleaned[key]);
        } else if (
          key === 'profile_image' &&
          cleaned[key].indexOf('media/') === -1
        ) {
          body = body.set(key, encodeURI(cleaned[key]));
        }

      return acc;
    });

    return this.http.patch<any>(`core/update-user/`, body);
  }


  forgotPassword(email: string) {
    const body = new HttpParams()
      .set(`email`, email)

    return this.http.post<any>("core/forgot-password/", body)
  }
}
